import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "./api";

const ContentCtx = createContext(() => undefined);

export function ContentProvider({ children }) {
  const [map, setMap] = useState({});
  useEffect(() => {
    api.getContent().then((r) => setMap(r.content || {})).catch(() => {});
  }, []);
  const cms = useCallback((key, fallback) => map[key] || fallback, [map]);
  return <ContentCtx.Provider value={cms}>{children}</ContentCtx.Provider>;
}

export function useContent() {
  return useContext(ContentCtx);
}
